import { redirect } from '@modern-js/runtime/router';

export const loader = async () => redirect('/notebook');
